import { Link } from "react-router-dom";
import { LegalLayout, H2, P, UL, LI } from "../components/site/LegalLayout";
import { EMAIL, PHONE_DISPLAY, ADDRESS_LINE1, ADDRESS_LINE2 } from "../lib/site";

export default function TermsOfUse() {
  return (
    <LegalLayout
      title="TERMS OF USE"
      updated="June 2026"
      intro="This website is for general information only. Nothing on it is a binding price quote or an offer to buy. All purchases are made in person at our yard, subject to actual grade, weight and current market conditions."
      testid="terms-of-use-page"
    >
      <H2>Acceptance of These Terms</H2>
      <P>
        By accessing or using this website, you agree to these Terms of Use and to our{" "}
        <Link to="/privacy-policy" className="text-red-700 font-semibold underline underline-offset-2">
          Privacy Policy
        </Link>
        . If you do not agree, please do not use this site. This website is operated by Scrapmans Metal
        Recycling LLC ("Scrapman's", "we", "us" or "our").
      </P>

      <H2>No Published Prices, No Binding Quotes</H2>
      <P>
        Scrap metal prices change constantly with the commodity market. This website does not publish prices,
        and any figure discussed by phone, email or in response to a quote request is an estimate only, given
        for the market conditions at that moment. It is not a guaranteed or binding price.
      </P>
      <UL>
        <LI>
          Final payment is always based on the actual material grade and verified weight determined at our
          scale at the time of purchase.
        </LI>
        <LI>
          We may decline any material or any load, for any lawful reason, including condition, contamination,
          prohibited items, or inability to verify lawful ownership.
        </LI>
        <LI>
          Submitting the bulk scrap form does not create a contract, reserve a price, or obligate either of
          us to complete a transaction.
        </LI>
      </UL>

      <H2>Bulk Scrap Quote Requests</H2>
      <P>
        When you submit a quote request you agree that the information you provide is accurate and that you
        are legally entitled to sell the material described. By uploading photos, you confirm you have the
        right to share them and you give us permission to use them internally to evaluate your load. Do not
        submit anything unlawful, misleading, or belonging to someone else without their permission.
      </P>

      <H2>Pickup and Service Availability</H2>
      <P>
        Pickup, container service and any other accommodation mentioned on this site may be available only
        for qualifying loads and depend on material, quantity, location, value, equipment availability and
        scheduling. Nothing on this site guarantees that a service is available to you.
      </P>

      <H2>Business Hours and Information</H2>
      <P>
        We work to keep hours, address, phone number and material lists current, but information on this site
        may change or contain errors. Hours may change for weather, holidays or operational reasons. Please
        call {PHONE_DISPLAY} before traveling a long distance.
      </P>

      <H2>Acceptable Use</H2>
      <UL>
        <LI>Do not use this site for any unlawful purpose or in violation of these terms.</LI>
        <LI>
          Do not attempt to gain unauthorized access to the site, its database, or any connected system, or
          interfere with its normal operation.
        </LI>
        <LI>
          Do not submit automated, repeated, fraudulent or spam submissions through our forms, or use this
          site to send unsolicited commercial messages to us.
        </LI>
        <LI>
          Do not scrape, copy or republish substantial portions of this site's content without our written
          permission.
        </LI>
      </UL>

      <H2>Intellectual Property</H2>
      <P>
        The Scrapman's name, logo, and the text, layout, graphics and design of this website are the property
        of Scrapmans Metal Recycling LLC or its licensors and are protected by applicable law. You may view
        and print pages for your own personal, non-commercial use. All other use requires our prior written
        permission.
      </P>

      <H2>Third-Party Links and Embeds</H2>
      <P>
        This site links to and embeds third-party services, including Google Maps and our Google Business
        profile. We do not control those services and are not responsible for their content, availability,
        accuracy or privacy practices.
      </P>

      <H2>Disclaimer of Warranties</H2>
      <P>
        This website and its content are provided "as is" and "as available," without warranties of any kind,
        express or implied, including any implied warranties of merchantability, fitness for a particular
        purpose, accuracy, or non-infringement. We do not warrant that the site will be uninterrupted,
        error-free, or free of harmful components.
      </P>

      <H2>Limitation of Liability</H2>
      <P>
        To the fullest extent permitted by law, Scrapmans Metal Recycling LLC and its members, employees and
        agents will not be liable for any indirect, incidental, special, consequential, exemplary or punitive
        damages, or for any lost profits, lost business, or loss of data, arising out of or relating to your
        use of this website or reliance on any information on it, even if we have been advised of the
        possibility of such damages. Where liability cannot be excluded, our total liability relating to this
        website is limited to one hundred dollars ($100). This section does not limit any rights you may have
        that cannot be limited under applicable law, and does not apply to our in-person purchase
        transactions, which are governed by their own terms and applicable Ohio law.
      </P>

      <H2>Indemnification</H2>
      <P>
        You agree to indemnify and hold harmless Scrapmans Metal Recycling LLC from any claims, losses,
        liabilities and expenses (including reasonable attorneys' fees) arising from your misuse of this
        website, your breach of these terms, or any inaccurate or unlawful information or material you submit
        to us.
      </P>

      <H2>Governing Law and Venue</H2>
      <P>
        These terms are governed by the laws of the State of Ohio, without regard to its conflict of laws
        rules. Any dispute relating to this website will be brought exclusively in the state or federal
        courts located in or serving Delaware County, Ohio, and you consent to the jurisdiction of those
        courts.
      </P>

      <H2>Changes to These Terms</H2>
      <P>
        We may revise these terms at any time by posting an updated version on this page. Your continued use
        of the site after changes are posted means you accept the revised terms.
      </P>

      <H2>Severability</H2>
      <P>
        If any provision of these terms is found unenforceable, the remaining provisions remain in full force
        and effect.
      </P>

      <H2>Contact Us</H2>
      <P>
        Scrapmans Metal Recycling LLC
        <br />
        {ADDRESS_LINE1}, {ADDRESS_LINE2}
        <br />
        Phone: {PHONE_DISPLAY}
        <br />
        Email:{" "}
        <a href={`mailto:${EMAIL}`} className="text-red-700 font-semibold underline underline-offset-2">
          {EMAIL}
        </a>
      </P>
    </LegalLayout>
  );
}
